import {useEffect, useState, setState} from 'react';
import React from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import { getFarmList } from '../../actions/farm';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CategorySetting = ({ isAuthenticated, clearTreeView, user, getFarmList }) => {
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState([]); 
    const [farms, setFarms] = useState([]); 
    const [allTress, setAllTrees] = useState([]); 
    const [selected, setSelected] = useState({});
    const [modalOpen, setModalOpen] = useState(false); 
    const classes = useStyles();
    const [defaultValues, setDefaultValues] = useState([]); 
    const [selectedState, setSelectedState ] = useState('');
    const [toSubmit, setToSubmit] = useState({});
    const [editModalOpen, setEditModalOpen] = useState(false); 
    const [addModalOpen, setAddModalOpen] = useState(false); 
    const [newFarmName, setNewFarmName] = useState(''); 
    
    const username = user ? user.username : (<Navigate to='/login'/>)


    useEffect(() => {
        // setFarms(["Penang","Johor","Melaka"])
        // setAllTrees(["HX-J-0001", "HX-J-0002", "HX-J-0004", "HX-M-0001", "HX-M-0002", "HX-M-0003", "HX-M-0004", "HX-M-0005", "HX-M-0006", "HX-M-0007", "HX-M-0008", "HX-M-0009", "HX-M-0010", "HX-M-0011", "HX-M-0012", "HX-M-0013", "HX-M-0014", "HX-M-0015", "HX-M-0016", "HX-M-0017", "HX-M-0018", "HX-M-0019", "HX-M-0020", "HX-M-0021", "HX-M-0022", "HX-M-0023", "HX-M-0024", "HX-M-0025", "HX-M-0026", "HX-M-0027", "HX-M-0028", "HX-M-0029", "HX-M-0030", "HX-M-0031", "HX-M-0032", "HX-M-0033", "HX-M-0034", "HX-M-0035", "HX-M-0036", "HX-M-0037", "HX-M-0038", "HX-M-0039", "HX-M-0040", "HX-M-0041", "HX-M-0042", "HX-M-0043", "HX-M-0044", "HX-M-0045", "HX-M-0046", "HX-M-0047", "HX-M-0048", "HX-M-0049", "HX-M-0050", "HX-M-0051", "HX-M-0052", "HX-M-0053", "HX-M-0054", "HX-M-0055", "HX-M-0056", "HX-M-0057", "HX-M-0058", "HX-M-0059", "HX-M-0060", "HX-M-0061", "HX-M-0062", "HX-M-0063", "HX-M-0064", "HX-M-0065", "HX-M-0066", "HX-M-0067", "HX-M-0068", "HX-M-0069", "HX-M-0070", "HX-M-0071", "HX-M-0072", "HX-M-0073", "HX-M-0074", "HX-M-0075", "HX-M-0076", "HX-M-0077", "HX-M-0078", "HX-M-0079", "HX-M-0080", "HX-M-0081", "HX-M-0082", "HX-M-0083", "HX-M-0084", "HX-M-0085", "HX-M-0086", "HX-M-0087", "HX-M-0088", "HX-M-0089", "HX-M-0090", "HX-M-0091", "HX-M-0092", "HX-M-0093", "HX-M-0094", "HX-M-0095", "HX-M-0096", "HX-M-0097", "HX-M-0098", "HX-M-0099", "HX-M-0100", "HX-M-0101", "HX-M-0102", "HX-M-0103", "HX-M-0104", "HX-M-0105", "HX-M-0106", "HX-M-0107", "HX-M-0108", "HX-M-0109", "HX-M-0110", "HX-M-0111", "HX-M-0112", "HX-M-0113", "HX-M-0114", "HX-M-0115", "HX-M-0116", "HX-M-0117", "HX-M-0118", "HX-M-0119", "HX-M-0120", "HX-M-0121", "HX-M-0122", "HX-M-0123", "HX-M-0124", "HX-M-0125", "HX-M-0126", "HX-M-0127", "HX-M-0128", "HX-M-0129", "HX-M-0130", "HX-M-0131", "HX-M-0132", "HX-M-0133", "HX-M-0134", "HX-M-0135", "HX-M-0136", "HX-M-0137", "HX-M-0138", "HX-M-0139", "HX-M-0140", "HX-M-0141", "HX-M-0142", "HX-M-0143", "HX-M-0144", "HX-M-0145", "HX-M-0146", "HX-M-0147", "HX-M-0148", "HX-M-0149", "HX-M-0150", "HX-M-0151", "HX-M-0152", "HX-M-0153", "HX-M-0154", "HX-M-0155", "HX-M-0156", "HX-M-0157", "HX-M-0158", "HX-M-0159", "HX-M-0160", "HX-M-0161", "HX-M-0162", "HX-M-0163", "HX-M-0164", "HX-M-0165", "HX-M-0166", "HX-M-0167", "HX-M-0168", "HX-M-0169", "HX-M-0170", "HX-M-0171", "HX-M-0172", "HX-M-0173", "HX-M-0174", "HX-M-0175", "HX-M-0176", "HX-M-0177", "HX-M-0178", "HX-M-0179", "HX-M-0180", "HX-M-0181", "HX-M-0182", "HX-M-0183", "HX-M-0184", "HX-M-0185", "HX-M-0186", "HX-M-0187", "HX-M-0188", "HX-M-0189", "HX-M-0190", "HX-M-0191", "HX-M-0192", "HX-M-0193", "HX-M-0194", "HX-M-0195", "HX-M-0196", "HX-M-0197", "HX-M-0198", "HX-M-0199", "HX-M-0200", "HX-M-0201", "HX-M-0202", "HX-M-0203", "HX-M-0204", "HX-M-0205", "HX-M-0206", "HX-M-0207", "HX-M-0208", "HX-M-0209", "HX-M-0210", "HX-M-0211", "HX-M-0212", "HX-M-0213", "HX-M-0214", "HX-M-0215", "HX-M-0216", "HX-M-0217", "HX-M-0218", "HX-M-0219", "HX-M-0220", "HX-M-0221", "HX-M-0222", "HX-M-0223", "HX-M-0224", "HX-M-0225", "HX-M-0226", "HX-M-0227", "HX-M-0228", "HX-M-0229", "HX-M-0230", "HX-M-0231", "HX-M-0232", "HX-M-0233", "HX-M-0234", "HX-M-0235", "HX-M-0236", "HX-M-0237", "HX-M-0238", "HX-M-0239", "HX-M-0240", "HX-M-0241", "HX-M-0242", "HX-M-0243", "HX-M-0244", "HX-M-0245", "HX-M-0246", "HX-M-0247", "HX-M-0248", "HX-M-0249", "HX-M-0250", "HX-M-0251", "HX-M-0252", "HX-M-0253", "HX-M-0254", "HX-M-0255", "HX-M-0256", "HX-M-0257", "HX-M-0258", "HX-M-0259", "HX-M-0260", "HX-M-0261", "HX-M-0262", "HX-M-0263", "HX-M-0264", "HX-M-0265", "HX-M-0266", "HX-M-0267", "HX-M-0268", "HX-M-0269", "HX-M-0270", "HX-M-0271", "HX-M-0272", "HX-M-0273", "HX-M-0274", "HX-M-0275", "HX-M-0276", "HX-M-0277", "HX-M-0278", "HX-M-0279", "HX-M-0280", "HX-M-0281", "HX-M-0282", "HX-M-0283", "HX-M-0284", "HX-M-0285", "HX-M-0286", "HX-M-0287", "HX-M-0288", "HX-M-0289", "HX-M-0290", "HX-M-0291", "HX-M-0292", "HX-M-0293", "HX-M-0294", "HX-M-0295", "HX-M-0296", "HX-M-0297", "HX-M-0298", "HX-M-0299", "HX-M-0300"])
        // let data = {
        //     "selected": [{
        //         "category": "Johor",
        //         "serial": "HX-J-0001"
        //     }, {
        //         "category": "Johor",
        //         "serial": "HX-J-0002"
        //     }, {
        //         "category": "Penang",
        //         "serial": "HX-M-0001"
        //     }, {
        //         "category": "Johor",
        //         "serial": "HX-M-0099"
        //     }],
        // }
        // let temp= {}
        // for (let item of data.selected) {
        //     console.log(123, item.category)
        //     if (item.category in temp) {
        //         temp[item.category] = [...temp[item.category], item.serial]
        //     } else {
        //         temp[item.category] = [item.serial]
        //     }
        // }
        // setSelected(temp)

        if (user){
            getData()
        }

    }, [user]);

    const getData = () => {
        setLoading(true)
        if (localStorage.getItem('access')) {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                }
            };
            axios.get(`${process.env.REACT_APP_API_URL}/tree/getUserFarm/${username}/`, config).then(function (response) {
                setFarms(response.data.farm)
    
                axios.get(`${process.env.REACT_APP_API_URL}/tree/getFarmTreeGroup/${username}/`, config).then(function (response) {
                    console.log(response);
                    setAllTrees(response.data.all_tree)
                    let temp = {}
                    console.log(23, response.data.selected)
                    for (let item of response.data.selected) {
                        console.log(123, item.category)
                        if (item.category in temp) {
                            temp[item.category] = [...temp[item.category], item.serial]
                        } else {
                            temp[item.category] = [item.serial]
                        }
                    }
                    setSelected(temp)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false)
                    console.log(error);
                });
    
            })
            .catch(function (error) {
                setLoading(false)
                console.log(error);
            });

        } else {
            console.log('Unauthorized. Please log in.')
        }
    }

    const submit = () => {
        setToSubmit({
            'selected': [],
            'deselected': [],
        })
        console.log('submit', selectedState, defaultValues, selected[selectedState])
        let temp_selected = []
        let temp_deselected = []
        for (let item of selected[selectedState]) {
            console.log(item, defaultValues.includes(item))
            if (!defaultValues.includes(item)) {
                temp_selected.push(
                    {
                        'username': username,
                        'farm': selectedState,
                        'serial': item
                    }
                )
            } 
        }

        for (let item of defaultValues) {
            if (!selected[selectedState].includes(item)) {
                temp_deselected.push(
                    {
                        'username': username,
                        'farm': selectedState,
                        'serial': item
                    }
                )
            }
        }
        console.log('temp_selected', temp_selected)
        console.log('temp_deselected', temp_deselected)
        setToSubmit({
            'selected': temp_selected,
            'deselected': temp_deselected,
        })

        

        if (localStorage.getItem('access')) {
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                }
            };
            setSubmitting(true)
            axios.post(`${process.env.REACT_APP_API_URL}/tree/saveFarmTreeGroup/${username}/`, {
                'selected': temp_selected,
                'deselected': temp_deselected,
            }, config).then(function (response) {
                console.log(response);
                setSubmitting(false)
                setModalOpen(false)
                alert('Succesfully updated!')
                // setData(response.data)
            })
            .catch(function (error) {
                console.log(error);
                setSubmitting(false)
                alert('Something wrong!')
            });
        } else {
            console.log('Unauthorized. Please log in.')
        } 
        
        
    }


    const handleOpen = (row) => {
        console.log('handleOpn', selected)
        for (let i in selected) {
            console.log(selected[i])
            if (i == row) {
                setDefaultValues(selected[i])
            }
        }
        setSelectedState(row)
        setModalOpen(!modalOpen)
    }
    const handleClose = () => {
        // console.log('handleClose', selected[selectedState])
        setSelected({
            ...selected,
            [selectedState]: defaultValues
        })
        setDefaultValues([])
        setSelectedState('')
        setToSubmit({
            'selected': [],
            'deselected': [],
        })
        setModalOpen(false);
        setNewFarmName('')

        // Edit
        setEditModalOpen(false)
        // Add
        setAddModalOpen(false)

    };


    const handleInput = (ev, newValue, reason) => {
        // console.log(ev.target.innerHTML, newValue)
        selected[selectedState] = newValue
        // console.log(123, selected)
    }
    

    const editFarm = (farm_name) => {
        setEditModalOpen(true)
        setNewFarmName(farm_name)
        setSelectedState(farm_name)
    }

    const submitEdit = () => {
        setSubmitting(true)
        axios.put(`${process.env.REACT_APP_API_URL}/tree/updateUserFarm/`, {
            'username': username,
            'selected': selectedState,
            'updated': newFarmName,
        }).then(function (response) {
            console.log(response);
            setSubmitting(false)
            setEditModalOpen(false)

            getFarmList(user.username)
            
            getData()
            alert('Succesfully updated!')
            // setData(response.data)
        })
        .catch(function (error) {
            console.log(error);
            setSubmitting(false)
            alert('Something wrong!')
        });
    }

    const deleteFarm = (farmName) => {
        if (window.confirm('Are you sure you want to delete farm?')) {
            if (localStorage.getItem('access')) {
                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                };

                setSubmitting(true)
                axios.post(`${process.env.REACT_APP_API_URL}/tree/deleteUserFarm/`, {
                    'username': username,
                    'farm': farmName,
                }, config).then(function (response) {
                    console.log(response);
                    setSubmitting(false)

                    getFarmList(user.username)

                    getData()
                    alert('Succesfully deleted!')
                })
                .catch(function (error) {
                    console.log(error);
                    setSubmitting(false)
                    alert('Something wrong!')
                });
            } else {
                console.log('Unauthorized. Please log in.')
            }
        }
    }

    const addFarm = () => {
        setAddModalOpen(true)
    }

    const submitAdd = () => {
        if (localStorage.getItem('access')) {
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            setSubmitting(true)
            axios.post(`${process.env.REACT_APP_API_URL}/tree/saveUserFarm/`, {
                "farm": [{
                    "username": username,
                    "farm": newFarmName
                }]
            }, config).then(function (response) {
                console.log(response);
                setSubmitting(false)
                setAddModalOpen(false)
    
                getFarmList(user.username)
    
                getData()
                alert('Succesfully Created!')
            })
            .catch(function (error) {
                console.log(error);
                setSubmitting(false)
                setAddModalOpen(false)
                alert('Something wrong!')
            });
        } else {
            console.log('Unauthorized. Please log in.')
        }
    }

    const handleInputChange = (event) => {
        setNewFarmName(event.target.value);
    }

    // if(!isAuthenticated) return  <Navigate to='/login'/>;

    if(loading){
        return (
            <div className='container'>
                <h3>Loading...</h3>
            </div>
          )
    }else{
        return (
            <div className='container'>
                
                    <div className={classes.addBtn}>
                        <Button variant="contained" color="primary" onClick={addFarm}>
                            Add Farm
                        </Button>
                    </div>

                    <TableContainer component={Paper}>
                        <Table  aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>List of User's Farm</TableCell>
                                </TableRow>
                            </TableHead>
                            
                            <TableBody>
                                {farms.map( (row) => (
                                    <TableRow key={row} >
                                        <TableCell component="th">
                                            <span>{row}</span>
                                            <IconButton onClick={() => { deleteFarm(row) }} disabled={submitting} color="default" style={{float:'right', padding: '0 10px'}}  aria-label="upload picture" component="span" >
                                                <DeleteIcon />
                                            </IconButton>
                                            <IconButton onClick={() => editFarm(row)} disabled={submitting} color="primary" style={{float:'right', padding: '0 10px'}}  aria-label="upload picture" component="span">
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton onClick={(event) => handleOpen(row)} color="primary" style={{float:'right', padding: '0 10px'}}  aria-label="upload picture" component="span" disabled={submitting}>
                                                <AddIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        

                <Modal
                    open={addModalOpen}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div  className={classes.modalContainer}>
                        <div className={classes.editField}>
                            <TextField 
                            fullWidth 
                            onChange={handleInputChange}
                            label="Please input farm name" />
                        </div>
                        <div className={classes.modalSubmitBtn}>
                            <Button onClick={handleClose} disabled={submitting}>
                                Cancel
                            </Button>
                            <Button color="primary" onClick={submitAdd} disabled={submitting}>
                                {submitting && (
                                    <CircularProgress />
                                )}
                                Submit
                            </Button>
                        </div>
                    </div>
                </Modal>
                
                <Modal
                    open={editModalOpen}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div  className={classes.modalContainer}>
                        <div className={classes.editField}>
                            <TextField 
                            fullWidth 
                            defaultValue={selectedState}
                            onChange={handleInputChange}
                            label="Please input farm name" />
                        </div>
                        <div className={classes.modalSubmitBtn}>
                            <Button onClick={handleClose} disabled={submitting}>
                                Cancel
                            </Button>
                            <Button color="primary" onClick={submitEdit} disabled={submitting}>
                                {submitting && (
                                    <CircularProgress />
                                )}
                                Submit
                            </Button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    open={modalOpen}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div  className={classes.modalContainer}>
                        <div  className={classes.autoComplete}>
                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={allTress}
                                defaultValue={defaultValues}
                                onChange={(event, newValue, reason) => {
                                    handleInput(event, newValue, reason)
                                }}
                                renderOption={(option, { selected }) => (
                                    <>
                                    <React.Fragment>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      />
                                      {option}
                                    </React.Fragment>
                                    </>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined"  placeholder="Select Trees" />

                                )}
                                style={{maxHeight: '35vh', overflowY: 'auto'}}
                            />
                        </div>

                        <div className={classes.modalSubmitBtn}>
                            <Button onClick={handleClose} disabled={submitting}>
                                Cancel
                            </Button>
                            <Button color="primary" onClick={submit} disabled={submitting}>
                                {submitting && (
                                    <CircularProgress />
                                )}
                                Submit
                            </Button>
                        </div>
                    </div>
                    
                </Modal>

            </div>
        )
    }

    
};

const useStyles = makeStyles((theme) => ({
    modalContainer: {
        width: '80%',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        margin: 'auto',
        marginTop: '200px',
    },
    autoComplete: {
        marginBottom: '30px',
    },
    modalSubmitBtn: {
        textAlign:'right'
    },
    editField: {
        width: '100%'
    },
    addBtn: {
        margin: ' 20px 0',
        float: 'right'
    }
}));

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user
});

export default connect(mapStateToProps, { getFarmList })(CategorySetting);

{/* <ArrowRight style={{float:'right'}}/> */}

// axios.get(`${process.env.REACT_APP_API_URL}/tree/getUserFarm/${username}/`).then(function (response) {
        //     console.log(response);
        //     setFarms(response.data)
        // })
        // .catch(function (error) {
        //     console.log(error);
        // });

        // axios.get(`${process.env.REACT_APP_API_URL}/tree/getFarmTreeGroup/${username}/`).then(function (response) {
        //     console.log(response);
        //     setData(response.data)
        // })
        // .catch(function (error) {
        //     console.log(error);
        // });



        // const loadOn = () => {
        //     classes.loader = {
        //         display:    'none',
        //         position:   'fixed',
        //         zIndex:    1000,
        //         top:        0,
        //         left:       0,
        //         height:     '100%',
        //         width:      '100%',
        //         background: "rgba( 255, 255, 255, .8 )  url('http://i.stack.imgur.com/FhHRx.gif')  50% 50%   no-repeat",
        //         overflow: 'hidden',  
        //         display: 'block',
        //     }
        // }
    
        // const loadOff = () => {
        //     classes.loader = {
        //         display:    'none',
        //         position:   'fixed',
        //         zIndex:    1000,
        //         top:        0,
        //         left:       0,
        //         height:     '100%',
        //         width:      '100%',
        //         background: "rgba( 255, 255, 255, .8 )  url('http://i.stack.imgur.com/FhHRx.gif')  50% 50%   no-repeat",
        //     }
        // }


        // setFarms(["Penang","Johor","Melaka"])
        // setAllTrees(["HX-J-0001", "HX-J-0002", "HX-J-0004", "HX-M-0001", "HX-M-0002", "HX-M-0003", "HX-M-0004", "HX-M-0005", "HX-M-0006", "HX-M-0007", "HX-M-0008", "HX-M-0009", "HX-M-0010", "HX-M-0011", "HX-M-0012", "HX-M-0013", "HX-M-0014", "HX-M-0015", "HX-M-0016", "HX-M-0017", "HX-M-0018", "HX-M-0019", "HX-M-0020", "HX-M-0021", "HX-M-0022", "HX-M-0023", "HX-M-0024", "HX-M-0025", "HX-M-0026", "HX-M-0027", "HX-M-0028", "HX-M-0029", "HX-M-0030", "HX-M-0031", "HX-M-0032", "HX-M-0033", "HX-M-0034", "HX-M-0035", "HX-M-0036", "HX-M-0037", "HX-M-0038", "HX-M-0039", "HX-M-0040", "HX-M-0041", "HX-M-0042", "HX-M-0043", "HX-M-0044", "HX-M-0045", "HX-M-0046", "HX-M-0047", "HX-M-0048", "HX-M-0049", "HX-M-0050", "HX-M-0051", "HX-M-0052", "HX-M-0053", "HX-M-0054", "HX-M-0055", "HX-M-0056", "HX-M-0057", "HX-M-0058", "HX-M-0059", "HX-M-0060", "HX-M-0061", "HX-M-0062", "HX-M-0063", "HX-M-0064", "HX-M-0065", "HX-M-0066", "HX-M-0067", "HX-M-0068", "HX-M-0069", "HX-M-0070", "HX-M-0071", "HX-M-0072", "HX-M-0073", "HX-M-0074", "HX-M-0075", "HX-M-0076", "HX-M-0077", "HX-M-0078", "HX-M-0079", "HX-M-0080", "HX-M-0081", "HX-M-0082", "HX-M-0083", "HX-M-0084", "HX-M-0085", "HX-M-0086", "HX-M-0087", "HX-M-0088", "HX-M-0089", "HX-M-0090", "HX-M-0091", "HX-M-0092", "HX-M-0093", "HX-M-0094", "HX-M-0095", "HX-M-0096", "HX-M-0097", "HX-M-0098", "HX-M-0099", "HX-M-0100", "HX-M-0101", "HX-M-0102", "HX-M-0103", "HX-M-0104", "HX-M-0105", "HX-M-0106", "HX-M-0107", "HX-M-0108", "HX-M-0109", "HX-M-0110", "HX-M-0111", "HX-M-0112", "HX-M-0113", "HX-M-0114", "HX-M-0115", "HX-M-0116", "HX-M-0117", "HX-M-0118", "HX-M-0119", "HX-M-0120", "HX-M-0121", "HX-M-0122", "HX-M-0123", "HX-M-0124", "HX-M-0125", "HX-M-0126", "HX-M-0127", "HX-M-0128", "HX-M-0129", "HX-M-0130", "HX-M-0131", "HX-M-0132", "HX-M-0133", "HX-M-0134", "HX-M-0135", "HX-M-0136", "HX-M-0137", "HX-M-0138", "HX-M-0139", "HX-M-0140", "HX-M-0141", "HX-M-0142", "HX-M-0143", "HX-M-0144", "HX-M-0145", "HX-M-0146", "HX-M-0147", "HX-M-0148", "HX-M-0149", "HX-M-0150", "HX-M-0151", "HX-M-0152", "HX-M-0153", "HX-M-0154", "HX-M-0155", "HX-M-0156", "HX-M-0157", "HX-M-0158", "HX-M-0159", "HX-M-0160", "HX-M-0161", "HX-M-0162", "HX-M-0163", "HX-M-0164", "HX-M-0165", "HX-M-0166", "HX-M-0167", "HX-M-0168", "HX-M-0169", "HX-M-0170", "HX-M-0171", "HX-M-0172", "HX-M-0173", "HX-M-0174", "HX-M-0175", "HX-M-0176", "HX-M-0177", "HX-M-0178", "HX-M-0179", "HX-M-0180", "HX-M-0181", "HX-M-0182", "HX-M-0183", "HX-M-0184", "HX-M-0185", "HX-M-0186", "HX-M-0187", "HX-M-0188", "HX-M-0189", "HX-M-0190", "HX-M-0191", "HX-M-0192", "HX-M-0193", "HX-M-0194", "HX-M-0195", "HX-M-0196", "HX-M-0197", "HX-M-0198", "HX-M-0199", "HX-M-0200", "HX-M-0201", "HX-M-0202", "HX-M-0203", "HX-M-0204", "HX-M-0205", "HX-M-0206", "HX-M-0207", "HX-M-0208", "HX-M-0209", "HX-M-0210", "HX-M-0211", "HX-M-0212", "HX-M-0213", "HX-M-0214", "HX-M-0215", "HX-M-0216", "HX-M-0217", "HX-M-0218", "HX-M-0219", "HX-M-0220", "HX-M-0221", "HX-M-0222", "HX-M-0223", "HX-M-0224", "HX-M-0225", "HX-M-0226", "HX-M-0227", "HX-M-0228", "HX-M-0229", "HX-M-0230", "HX-M-0231", "HX-M-0232", "HX-M-0233", "HX-M-0234", "HX-M-0235", "HX-M-0236", "HX-M-0237", "HX-M-0238", "HX-M-0239", "HX-M-0240", "HX-M-0241", "HX-M-0242", "HX-M-0243", "HX-M-0244", "HX-M-0245", "HX-M-0246", "HX-M-0247", "HX-M-0248", "HX-M-0249", "HX-M-0250", "HX-M-0251", "HX-M-0252", "HX-M-0253", "HX-M-0254", "HX-M-0255", "HX-M-0256", "HX-M-0257", "HX-M-0258", "HX-M-0259", "HX-M-0260", "HX-M-0261", "HX-M-0262", "HX-M-0263", "HX-M-0264", "HX-M-0265", "HX-M-0266", "HX-M-0267", "HX-M-0268", "HX-M-0269", "HX-M-0270", "HX-M-0271", "HX-M-0272", "HX-M-0273", "HX-M-0274", "HX-M-0275", "HX-M-0276", "HX-M-0277", "HX-M-0278", "HX-M-0279", "HX-M-0280", "HX-M-0281", "HX-M-0282", "HX-M-0283", "HX-M-0284", "HX-M-0285", "HX-M-0286", "HX-M-0287", "HX-M-0288", "HX-M-0289", "HX-M-0290", "HX-M-0291", "HX-M-0292", "HX-M-0293", "HX-M-0294", "HX-M-0295", "HX-M-0296", "HX-M-0297", "HX-M-0298", "HX-M-0299", "HX-M-0300"])
        // console.log(farms)
        // let data = {
        //     "selected": [{
        //         "category": "Johor",
        //         "serial": "HX-J-0001"
        //     }, {
        //         "category": "Johor",
        //         "serial": "HX-J-0002"
        //     }, {
        //         "category": "Penang",
        //         "serial": "HX-M-0001"
        //     }, {
        //         "category": "Johor",
        //         "serial": "HX-M-0099"
        //     }],
        // }